import { DataPreFilledType } from '../../constants';
import { DocumentModel } from '../../data/interfaces/Document';
import { DocumentTemplate } from '../../data/interfaces/DocumentTemplate';
import { pendoSendTrackEvent } from '../tracking';
import { getFieldsDetails } from './helper';

export const sendDocumentTemplatePendoTrackingEvent = function (
	eventName: string,
	documentTemplate: DocumentTemplate
) {
	const metadata = {
		documentTemplateId: documentTemplate?.id,
		variables: documentTemplate?.variables?.map(variable => variable?.name),
		variableCount: documentTemplate?.variables?.length,
		dataSources: Array.from(
			new Set(documentTemplate?.variables?.map(variable => variable?.provider))
		),
		entities: documentTemplate?.variables?.map(
			variable => variable?.provider + '.' + variable?.entity
		),
		fieldCount: documentTemplate?.fields?.length,
		systemFilledFieldCount: documentTemplate?.fields?.filter(
			field => field?.dataPreFilledType === DataPreFilledType.SourceMapped
		)?.length,
		// using key as signerRoles as roles is being used in ShareFile UI for user roles
		// https://code.citrite.net/projects/wapp/repos/sharefile-ui/browse/src/Components/Pendo/pendo.ts?at=6de95c46e39af1fc0d47158555325eb1186656c9#78
		signerRoles: documentTemplate?.roles?.map(role => role?.name),
		roleCount: documentTemplate?.roles?.length,
		status: documentTemplate?.status,
		kba: documentTemplate?.isKbaEnabled,
		hasPasscode: documentTemplate?.isPasscodeEnabled,
	};
	const metadataWithFields = {
		...metadata,
		...getFieldsDetails(documentTemplate?.fields || []),
	};
	pendoSendTrackEvent(eventName, metadataWithFields);
};

export const sendDocumentPendoTrackingEvent = function (
	eventName: string,
	document: DocumentModel,
	signatureRequestType: string
) {
	const metadata = {
		documentId: document?.rid?.split('document-')?.pop(),
		documentTemplateId: document?.parentId,
		signatureRequestType,
		variables: document?.variables?.map(variable => variable?.name),
		variableCount: document?.variables?.length,
		dataSources: Array.from(
			new Set(document?.variables?.map(variable => variable?.provider))
		),
		entities: document?.variables?.map(
			variable => variable?.provider + '.' + variable?.entity
		),
		fieldCount: document?.fields?.length,
		systemFilledFieldCount: document?.fields?.filter(
			field => field?.dataPreFilledType === DataPreFilledType.SourceMapped
		)?.length,
		// using key as signerRoles as roles is being used in ShareFile UI for user roles
		// https://code.citrite.net/projects/wapp/repos/sharefile-ui/browse/src/Components/Pendo/pendo.ts?at=6de95c46e39af1fc0d47158555325eb1186656c9#78
		signerRoles: document?.roles?.map(role => role?.name),
		roleCount: document?.roles?.length,
		kba: document?.settings?.isKbaEnabled,
		hasPasscode: document?.settings?.isPasscodeEnabled,
	};
	const metadataWithFields = {
		...metadata,
		...getFieldsDetails(document?.fields || []),
	};
	pendoSendTrackEvent(eventName, metadataWithFields);
};

export const sendDocumentForSignatureUpdateFieldPendoTrackingEvent = function (
	eventName: string,
	document: DocumentModel,
	editedFields: any
) {
	const metadata = {
		documentId: document?.rid?.split('document-')?.pop(),
		documentTemplateId: document?.parentId,
		variables: document?.variables?.map(variable => variable?.name),
		variableCount: document?.variables?.length,
		dataSources: Array.from(
			new Set(document?.variables?.map(variable => variable?.provider))
		),
		entities: document?.variables?.map(
			variable => variable?.provider + '.' + variable?.entity
		),
		systemFilledFieldCount: document?.fields?.filter(
			field => field?.dataPreFilledType === DataPreFilledType.SourceMapped
		)?.length,
		editedFields,
	};
	pendoSendTrackEvent(eventName, metadata);
};
